import backendAPI from '../axiosConfig'

const baseUrl = process.env.REACT_APP_BACKEND_URL + '/api'
// custom baseQuery using Axios
export default () =>
  async ({ url, method, data, params }) => {
    try {
      const result = await backendAPI({
        url: baseUrl + url,
        method,
        data,
        params,
      })
      return { data: result.data }
    } catch (axiosError) {
      let err = axiosError
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      }
    }
  }
